
import profilePhoto from './Headshot1.png'

export const data = {
  photo: profilePhoto,
  header: {
    en: "Hello! My name is Jeff Mostyn, career software engineer and hobbyist game developer.",
    ja: "私はソフトウェア・エンジニアでゲーム・プログラマー趣味者のJeffrey Mostynです。このページに訪ねてくれてありがとうございます。"
  },
  bio: [
    {
      en: "Front-end Engineer of 6 years at Comcast in Philadelphia",
      ja: "6年間株式会社コムキャストでフロントエンド・エンジニアを務めています。"
    }, 
    {
      en: "Master's student at the University of Pennsylvania, studying Computer Graphics & Game Technology",
      ja: "現在はペンシルバニア大学でコンピューター・グラフィックス修士のために勉強している大学院生です。"
    },
    {
      en: "Drexel University graduate, with a Bachelor's of Science with Honors in Computer Science & concentration in Game Programming",
      ja: "コンピューターサイエンスとゲームプログラミング専攻のドレクセル大学光栄卒業者です。"
    },
    {
      en: "My favorite games include Magic: the Gathering, SMITE (soon SMITE 2?), and TES IV: Oblivion",
      ja: "好きなゲームは、Magic: the GatheringというカードゲームとSMITEとThe Elder Scrolls IV: Oblivionを含む。"
    },
    {
      en: "Music lover - I've played saxophone since the 4th grade, as well as guitar and bass" ,
      ja: "私は音楽がいつから大好きでした。小学校からサクソフォンを弾いて、最近ギターもベースギターも弾いています。"
    },
    {
      en: "I picked up learning Japanese as a hobby during COVID and am comfortably conversational in the language, and constantly improving.",
      ja: "コロナウイルスの時に日本語の勉強を趣味として初めて、今まで日本語能力試験のN4まで合格したことがあります。ですが、もっと上手になりたくて、勉強を続けています。"
    }
  ]
}